<template>
    <div class="app-container pagelivreurs">
        <el-row class="toprow is-text-align-right">
            <el-select
                v-model="activeLivreurId"
                placeholder="Select"
                style="width: 300px"
            >
                <el-option
                    v-for="livreur in livreurs"
                    :key="'liv' + livreur.id"
                    :label="livreur.nom + ' - ' + etats[livreur.etat]"
                    :value="livreur.id"
                />
            </el-select>
            <el-tooltip content="Données livreur">
                <el-link
                    type="success"
                    size="small"
                    icon="el-icon-edit"
                    @click="editLivreur()"
                />
            </el-tooltip>
            <el-tooltip content="Nouveau livreur">
                <el-link
                    type="success"
                    size="small"
                    icon="el-icon-plus"
                    @click="createLivreur()"
                />
            </el-tooltip>
        </el-row>
        <livraisonprix
            v-if="livreurs"
            :livreur="activeLivreur"
            :parent="this"
        />
        <el-button @click="importexcel">importer tarifs Excel</el-button>
        <el-table
            v-loading="loading"
            :data="activeLivreur.tarifs"
            border
            fit
            highlight-current-row
            style="width: 100%"
        >
            <el-table-column align="left" label="Dép" width="250" prop="nom">
                <template slot-scope="scope">
                    <span>{{ scope.row.code }} - {{ scope.row.nom }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-for="(colmax, i) in maxcolsview"
                :key="'col' + i"
                align="center"
                :label="'max' + colmax"
                width="120"
                :prop="'max' + colmax"
            >
                <template slot-scope="scope">
                    <span
                        @click="
                            editTarif(
                                scope.row.id,
                                colmax,
                                scope.row.tarifs[colmax]
                            )
                        "
                    >
                        {{
                            Number.parseFloat(scope.row.tarifs[colmax]).toFixed(
                                2
                            )
                        }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                align="left"
                label="Taxe montagne"
                width="250"
                prop="nom"
            >
                <template slot-scope="scope">
                    <span
                        @click="
                            editTaxmontagne(
                                scope.row.id,
                                scope.row.cps_montagne
                            )
                        "
                        v-html="
                            scope.row.cps_montagne.length
                                ? scope.row.cps_montagne.join()
                                : 'ajouter'
                        "
                    />
                </template>
            </el-table-column>
        </el-table>
        <livreur
            :isvisible="dialogLivreurVisible"
            :livreur="activeLivreur"
            :parent="this"
        />
    </div>
</template>

<script>
import Resource from "@/api/resource";
const livreurResource = new Resource("livreurs");
import livreur from "@/components/Livreur";
import livraisonprix from "@/components/Livraisonprix";

export default {
    name: "Livreurs",
    components: {
        livreur,
        livraisonprix
    },
    data() {
        return {
            maxcolsview: ["6", "12", "18", "24"],
            loading: false,
            livreurs: null,
            dialogLivreurVisible: false,
            activeLivreur: {},
            activeLivreurId: null,
            etats: {
                actif: "Actif",
                inactif: "Inactif"
            }
        };
    },
    created() {
        console.log("getLivreurs");
        this.getLivreurs();
    },
    watch: {
        activeLivreurId(val) {
            if (val && this.livreurs) {
                this.activeLivreur = this.livreurs.find(
                    livreur => livreur.id === val
                );
                console.log(this.activeLivreurId);
                console.log(this.activeLivreur);
            }
        }
    },
    methods: {
        createLivreur() {
            this.activeLivreur = {
                nom: "nouveau",
                etat: "inactif"
            };
            this.dialogLivreurVisible = true;
        },
        importexcel() {
            this.activeLivreur["departement_id"] = null;
            this.activeLivreur["maxcol"] = null;
            this.activeLivreur["data"] = null;
            this.activeLivreur["cps_montagne"] = null;
            this.activeLivreur["excel"] = true;
            this.dialogLivreurVisible = true;
        },
        editTarif(dep, maxcol, data) {
            this.activeLivreur["departement_id"] = dep;
            this.activeLivreur["maxcol"] = maxcol;
            this.activeLivreur["data"] = data;
            this.activeLivreur["cps_montagne"] = null;
            this.dialogLivreurVisible = true;
        },
        editTaxmontagne(dep, cps_montagne) {
            this.activeLivreur["departement_id"] = dep;
            this.activeLivreur["maxcol"] = null;
            this.activeLivreur["data"] = null;
            this.activeLivreur["cps_montagne"] = cps_montagne;

            this.dialogLivreurVisible = true;
        },
        editLivreur() {
            console.log("editLivreur");
            this.activeLivreur["departement_id"] = null;
            this.activeLivreur["maxcol"] = null;
            this.activeLivreur["data"] = null;
            this.activeLivreur["cps_montagne"] = null;
            this.dialogLivreurVisible = true;
        },
        async getLivreurs() {
            console.log("getLivreurs");
            this.loading = true;
            const { data } = await livreurResource.list({});
            this.livreurs = data;
            this.activeLivreur = data[0];
            this.activeLivreurId = data[0].id;
            this.loading = false;
            console.log(this.livreurs);
        },
        callbackLivreur(reload, livreur) {
            if (reload) {
                this.getLivreurs();
            }
            if (livreur) {
                Object.assign(this.activeLivreur, livreur);
            }
        }
    }
};
</script>
